import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'; // Importar FormsModule

import { AppComponent } from './app.component';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import {RouterOutlet} from "@angular/router";
import { ChatItemComponent } from './chat-item/chat-item.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CookieService} from "ngx-cookie-service";
import {HttpClientModule} from "@angular/common/http";
import { LinkifyPipe } from './pipes/linkify.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ChatWidgetComponent,
    ChatItemComponent,
    LinkifyPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterOutlet,
    // Agregar FormsModule aquí
    FontAwesomeModule,
    BrowserAnimationsModule,
    HttpClientModule
  ],
  providers: [CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }
